import React from 'react';
export default class MinimalResumeReference extends React.Component{

    getResumeBlock(data, index){
        let title = [];
        if (data.name){
            title.push(<span key="a" data-v-b8233322="">{data.name}</span>)
        }

        if (data.title){
            title.push(<span key="b" data-v-b8233322="">{data.title}</span>)
        }

        if (data.companyName){
            title.push(<span key="c" data-v-b8233322="">{data.companyName}</span>)
        }

        let titleFinal = [];
        for(let i = 0; i < title.length; i++){
            titleFinal.push(title[i]);
            if(i + 1 < title.length){
                titleFinal.push(<span key={i} data-v-b8233322="" className="comma">, </span>)
            }
        }

        return  <div data-v-b8233322="" className="section-item" key={index}>
                    <div data-v-b8233322="" className="section-title">
                        {titleFinal}
                    </div>
                    {data.email && <div data-v-b8233322="" className="section-description">{data.email}</div>}
                    {data.phone && <div data-v-b8233322="" className="section-description">{data.phone}</div>}
                    {data.address && <div data-v-b8233322="" className="section-description">{data.address}</div>}
                </div>
    }

    render(){
        return  <div data-v-b8233322="" className="section">
                    <div data-v-b8233322="" className="section-headline">{this.props.title}</div>
                    {this.props.data.map((item, index) => {
                        return this.getResumeBlock(item, index);
                    })}
                </div>

    }
}